import { useCallback, useState } from 'react';

/**
 * Returns a function that schedules a re-render of the calling component.
 * Implemented with an internal counter so each call produces a new render.
 */
export function useForceUpdate(): () => void {
  const [, setTick] = useState(0);

  return useCallback(() => {
    setTick((n) => n + 1);
  }, []);
}
